import _ from 'lodash';
import moment from 'moment-timezone';


    var defaultFormat = 'MMM D, YYYY';

    function DateRangeManager(params) {
        this.initialize(params);
    }

    DateRangeManager.prototype = {
        getConfiguration: function (isInternalUser) {
            var dateRange = this.dateRange;
            var defaultDateRangeConf = {
                maxSpan: {
                    days: 2920  // 8 yrs; maxSpan replaces dateLimit
                },
                endDate: dateRange.endDate,
                maxDate: this.getThisMoment().subtract(1, 'day').endOf('day'),
                minDate: this.getThisMoment().subtract(10, 'year').startOf('month').subtract(1, 'day'),
                opens: "left",
                startDate: dateRange.startDate,
                ranges: this.getRanges(null, isInternalUser)
            };
            return _.extend({}, defaultDateRangeConf, _.get(this.params, 'dateRangeOptions', {}));
        },

        getDateRange: function () {
            return this.dateRange;
        },

        getDefaultRange: function () {
            return this.getRanges('Previous Month');
        },

        getFormattedDate: function (date) {
            return moment(date).format(defaultFormat);
        },

        getFormattedDateRange: function () {
            return this.getFormattedDate(this.dateRange.startDate) + ' - ' +
                this.getFormattedDate(this.dateRange.endDate);
        },

        getRanges: function (rangeName, isInternalUser) {
            var ffyStart;
            if (this.getThisMoment().month() >= 9) {
                ffyStart = this.getThisMoment().month(9).date(1); // October 1 this year
            } else {
                ffyStart = this.getThisMoment().subtract(1, 'year').month(9).date(1); // October 1 last year
            }

            var allRanges = {
                'Yesterday': [
                    this.getThisMoment().subtract(1, 'days'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Last 7 Days': [
                    this.getThisMoment().subtract(7, 'days'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Last 30 Days': [
                    this.getThisMoment().subtract(30, 'days'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'This Month': [
                    this.getThisMoment().startOf('month'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Previous Month': [
                    this.getThisMoment().subtract(1, 'month').startOf('month'),
                    this.getThisMoment().subtract(1, 'month').endOf('month')
                ],
                'Last 3 Months': [
                    this.getThisMoment().subtract(3, 'month').startOf('month'),
                    this.getThisMoment().subtract(1, 'month').endOf('month')
                ],
                'Last 12 Months': [
                    this.getThisMoment().subtract(12, 'month').startOf('month'),
                    this.getThisMoment().subtract(1, 'month').endOf('month')
                ],
                'Week to date': [
                    this.getThisMoment().subtract(1, 'days').startOf('isoWeek'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Month to date': [
                    this.getThisMoment().subtract(1, 'days').startOf('month'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Quarter to date': [
                    this.getThisMoment().subtract(1, 'days').startOf('quarter'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Year to date': [
                    this.getThisMoment().subtract(1, 'days').startOf('year'),
                    this.getThisMoment().subtract(1, 'days')
                ],
                'Federal Fiscal Year to date': [
                    ffyStart,
                    this.getThisMoment().subtract(1, 'days')
                ]
            };
            
            if (isInternalUser) {
                allRanges['Last 10 Years'] = [
                    this.getThisMoment().subtract(10, 'years').startOf('month'),
                    this.getThisMoment().subtract(1, 'days')
                ]
            }

            return _.get(allRanges, rangeName, allRanges);
        },

        getThisMoment: function () {
            return moment.tz(_.get(this.getTimezone(), 'id'));
        },

        getTimezone: function () {
            return this.timezone;
        },

        initialize: function (params) {
            var endDate;
            var startDate;

            this.params = params;
            this.timezone = {
                id: _.get(params, 'timezone.id', ''),
                text: _.get(params, 'timezone.text', '')
            };

            var defaultRange = this.getDefaultRange();
            if (!_.isNil(params)) {
                startDate = moment(_.get(params, 'dateRange.startDate', _.first(defaultRange)));
                endDate = moment(_.get(params, 'dateRange.endDate', _.last(defaultRange)));

            } else {
                startDate = _.first(defaultRange);
                endDate = _.last(defaultRange);
            }

            this.updateDateRange(startDate, endDate);
        },

        updateDateRange: function (start, end) {
            this.dateRange = {
                startDate: start,
                endDate: end
            };
        }
    };

    export default DateRangeManager;
